<template>
  <div>
    <div class="panel animated fadeInRightBig">
      <div class="panel-heading">
        <div class="panel-title">
          <span>
            <b>Nova Área do Processo</b>
            <i
              class="fa fa-user-circle"
              style="float: right; margin-top: 6px; font-size: 21px"
            ></i>
            <hr />
          </span>
        </div>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <span class="required">*</span>
              <label for="process_areas">Área de Processo:</label>
              <input
                type="text"
                class="form-control"
                id="process_areas"
                v-model="process_areas.process_areas"
                autocomplete="false"
              />
            </div>
          </div>
        </div>

        <div class="block text-right">
          <a class="btn btn-success" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
          <router-link to="/process_areas" class="btn btn-info">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b><span class="required">*</span> Campos Obrigatórios</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      process_areas: {
        process_areas: "",
      },

      errors: undefined,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const api = this.$store.state.api + "process_areas";
      const self = this;

      self.$http
        .post(api, self.process_areas)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Área de Processo cadastrado com sucesso`,
            "success"
          );
          this.$router.push("/process_areas");
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
